import { render } from "./NotFound.vue?vue&type=template&id=f82357ee"
import script from "./NotFound.vue?vue&type=script&lang=js"
export * from "./NotFound.vue?vue&type=script&lang=js"

import exportComponent from "/home/afs/ASF/Release/jena/target/checkout/jena-fuseki2/jena-fuseki-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__